import React, { ReactElement } from 'react';
import CcxComponentProps from '../../../core/CcxComponent';
import AppCdnSvg from './AppCdnSvg';
import styles from './AppLogoBrand.module.less';

interface Props extends CcxComponentProps {
    height?: number;
    logo: string;
    size: string | number;
    width?: number;
}

function AppCdnLogo({
    className,
    height,
    logo,
    size,
    testId,
    width,
}: Props): ReactElement {
    return (
        <AppCdnSvg
            className={className || styles.AppCdnLogo}
            filename={`logo/${logo}`}
            height={height}
            size={size || 'xlarge'}
            testId={testId || 'AppCdnLogo'}
            width={width}
        />
    );
}

export default AppCdnLogo;
